import { render, staticRenderFns } from "./StudioAnnouncement.vue?vue&type=template&id=81cd8472&scoped=true&"
import script from "./StudioAnnouncement.vue?vue&type=script&lang=js&"
export * from "./StudioAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./StudioAnnouncement.vue?vue&type=style&index=0&id=81cd8472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cd8472",
  null
  
)

export default component.exports